import * as React from "react";
import type { TypeSegmentedControlProps } from "./SegmentedControlTypes";
import SegmentedControlHybrid from "./SegmentedControlHybrid";
import { SegmentedControlItem } from "./SegmentedControlTailwind";

type TypeSegmentedControlComponent = React.ForwardRefExoticComponent<
  TypeSegmentedControlProps & React.RefAttributes<HTMLDivElement>
> & {
  Item: typeof SegmentedControlItem;
};

/**
 * SegmentedControl routes between the Tailwind/CSS-class implementation
 * (preferred) and the legacy styled-components implementation via the hybrid
 * component. This entry file keeps a real component definition (mirroring
 * Button.tsx) so react-docgen's `generate:props-docs` step can discover it and
 * emit prop docs from TypeSegmentedControlProps. styles.ts is left untouched
 * for the styled path.
 */
const SegmentedControl = React.forwardRef<
  HTMLDivElement,
  TypeSegmentedControlProps
>((props, ref) => (
  <SegmentedControlHybrid {...props} ref={ref} />
)) as TypeSegmentedControlComponent;

SegmentedControl.displayName = "SegmentedControl";
SegmentedControl.Item = SegmentedControlItem;

export default SegmentedControl;
